// import React, { useState } from "react";
// import CardsBorder from "../../../components/Cards/CardsBorder";
// import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
// import GenerateReport from "../DailogBox/GenerateReport";
// import { useLocation } from "react-router-dom";
// import { getApi } from "../../../api/api_instance";
// import { API_URLS } from "../../../api/apiUrls";
// const CustomerReportBasicDetails = () => {
//   const [openStaticGeneratePopup, setOpenStaicGeneratePopup] = useState(false);
//   const statusList = ["Draft", "Sent For Approval", "Approved"];
//   const currentStatus = "Sent For Approval";

//   return (
//     <div>
//       <CardsBorder>
//         <div className="flex justify-between pt-4">
//           <div className="pl-16">
//             <div className="flex gap-8">
//               <div>
//                 <p className="font-semibold">CUSTOMER NAME</p>
//                 <p className="font-light">TATA SONS PVT. LTD </p>
//               </div>
//               <div>
//                 <p className="font-semibold">PROJECT TYPE</p>
//                 <p className="font-light">ESG REPORTING</p>
//               </div>
//             </div>
//             <div className="flex gap-8 py-6">
//               <div>
//                 <p className="font-semibold">PROJECT NAME</p>
//                 <p className="font-light">YP/FC/1024/001</p>
//               </div>
//               <div>
//                 <p className="font-semibold">REQUESTED ON</p>
//                 <p className="font-light">10/02/2025</p>
//               </div>
//             </div>
//           </div>
//           <div>
//             <p>Status</p>
//             <div className="relative ">
//               <ul className="relative text-[12px] space-y-0">
//                 {statusList.map((status, idx) => {
//                   const isActive = status === currentStatus;
//                   const isCompleted =
//                     statusList.indexOf(status) <
//                     statusList.indexOf(currentStatus);
//                   const isLast = idx === statusList.length - 1;

//                   return (
//                     <li key={idx} className="flex gap-2 relative">
//                       {/* Dot + Line */}
//                       <div className="flex flex-col items-center">
//                         {/* Dot */}
//                         <div
//                           className={`w-2 h-2 rounded-full ${
//                             isActive || isCompleted
//                               ? "bg-[#38A28D]"
//                               : "bg-gray-300"
//                           }`}
//                         ></div>

//                         {/* Line below the dot */}
//                         {!isLast && (
//                           <div
//                             className={`w-[2px] flex-1 ${
//                               isCompleted ? "bg-[#38A28D]" : "bg-gray-300"
//                             }`}
//                             style={{ minHeight: "30px" }}
//                           ></div>
//                         )}
//                       </div>

//                       {/* Status text */}
//                       <div>
//                         <span
//                           className={`${
//                             isActive
//                               ? "text-[#06513D] font-semibold"
//                               : isCompleted
//                               ? "text-gray-700"
//                               : "text-gray-400"
//                           }`}
//                         >
//                           {status}
//                         </span>
//                       </div>
//                     </li>
//                   );
//                 })}
//               </ul>
//             </div>
//           </div>
//           <div className="flex gap-2 px-4">
//             <CustomButton
//               buttonType="primary"
//               variant="ok"
//               buttonText="Export Form Assigned"
//               className="text-xs h-[50px]"
//               // onClick={handleOpenAddNew}
//             />
//             <CustomButton
//               buttonType="primary"
//               variant="ok"
//               buttonText="Start Generate Report"
//               className="text-xs h-[50px]"
//               onClick={() => setOpenStaicGeneratePopup(true)}
//               // onClick={handleOpenAddNew}
//             />
//           </div>
//         </div>
//       </CardsBorder>
//       {openStaticGeneratePopup && (
//         <GenerateReport
//           open={openStaticGeneratePopup}
//           onCancel={() => setOpenStaicGeneratePopup(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default CustomerReportBasicDetails;

import React, { useState, useEffect, useCallback } from "react";
import CardsBorder from "../../../components/Cards/CardsBorder";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import GenerateReport from "../DailogBox/GenerateReport";
import { useLocation } from "react-router-dom";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";

const CustomerReportBasicDetails = ({onReloadReports}) => {
  const [openStaticGeneratePopup, setOpenStaicGeneratePopup] = useState(false);
  const [reportDetails, setReportDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
   const [refresh, setRefresh] = useState(false);
  // Get reportId from navigation state
  const { reportId } = location.state || {};
  
  console.log("Report ID:", reportId);

  // Dynamic status list - only 2 statuses
  const statusList = ["in_process", "completed"];
  
  // Status display mapping
  const STATUS_DISPLAY = {
    in_process: "In Process",
    completed: "Completed",
  };

  // Get current status from API response
  const currentStatus = reportDetails?.status || "in_process";

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
  };

  // Fetch report details
  const fetchReportDetails = useCallback(async () => {
    if (!reportId) {
      console.error("No report ID provided");
      return;
    }

    setLoading(true);
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_CUSTOMER_REPORT_DETAILS(reportId),
      });

      console.log("Report Details Response:", response);
      
      if (response?.data) {
        setReportDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching report details:", error);
    } finally {
      setLoading(false);
    }
  }, [reportId]);

  useEffect(() => {
    if (reportId) {
      fetchReportDetails();
    }
  }, [fetchReportDetails, reportId,refresh]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <p>Loading report details...</p>
      </div>
    );
  }
 const handleCancel = () => {
    setOpenStaicGeneratePopup(false);
   if (onReloadReports) onReloadReports(); // ✅ force re-render
  };

  return (
    <div>
      <CardsBorder>
        <div className="flex justify-between pt-4">
          <div className="pl-16">
            <div className="flex gap-8">
              <div>
                <p className="font-semibold">CUSTOMER NAME</p>
                <p className="font-light">
                  {reportDetails?.client_id?.name || "N/A"}
                </p>
              </div>
              <div>
                <p className="font-semibold">PROJECT TYPE</p>
                <p className="font-light">
                  {reportDetails?.project_id?.project_type || "N/A"}
                </p>
              </div>
            </div>
            <div className="flex gap-8 py-6">
              <div>
                <p className="font-semibold">PROJECT NAME</p>
                <p className="font-light">
                  {reportDetails?.project_id?.name || "N/A"}
                </p>
              </div>
              <div>
                <p className="font-semibold">REQUESTED ON</p>
                <p className="font-light">
                  {reportDetails?.requested_on 
                    ? formatDate(reportDetails.requested_on)
                    : "N/A"}
                </p>
              </div>
            </div>
          </div>
          
          {/* Dynamic Status Section */}
          <div className="pr-16">
            <p className="font-semibold mb-2">Status</p>
            <div className="relative">
              <ul className="relative text-[12px] space-y-0">
                {statusList.map((status, idx) => {
                  const isActive = status === currentStatus;
                  const isCompleted =
                    statusList.indexOf(status) < statusList.indexOf(currentStatus);
                  const isLast = idx === statusList.length - 1;

                  return (
                    <li key={idx} className="flex gap-2 relative">
                      {/* Dot + Line */}
                      <div className="flex flex-col items-center">
                        {/* Dot */}
                        <div
                          className={`w-2 h-2 rounded-full ${
                            isActive || isCompleted
                              ? "bg-[#38A28D]"
                              : "bg-gray-300"
                          }`}
                        ></div>

                        {/* Line below the dot */}
                        {!isLast && (
                          <div
                            className={`w-[2px] flex-1 ${
                              isCompleted ? "bg-[#38A28D]" : "bg-gray-300"
                            }`}
                            style={{ minHeight: "30px" }}
                          ></div>
                        )}
                      </div>

                      {/* Status text */}
                      <div>
                        <span
                          className={`${
                            isActive
                              ? "text-[#06513D] font-semibold"
                              : isCompleted
                              ? "text-gray-700"
                              : "text-gray-400"
                          }`}
                        >
                          {STATUS_DISPLAY[status] || status}
                        </span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          <div className="flex gap-2 px-4">
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Export Form Assigned"
              className="text-xs h-[50px]"
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Start Generate Report"
              className="text-xs h-[50px]"
              onClick={() => setOpenStaicGeneratePopup(true)}
            />
          </div>
        </div>
      </CardsBorder>
      {openStaticGeneratePopup && (
        <GenerateReport
          open={openStaticGeneratePopup}
          // onCancel={() => setOpenStaicGeneratePopup(false)}
          onCancel={handleCancel}
          reportId={reportId}
          reportDetails={reportDetails}
        />
      )}
    </div>
  );
};

export default CustomerReportBasicDetails;